// import Image from 'Assets/index'
// import { useAuth } from 'Context/authContext'
// import { useNavigate } from 'react-router-dom'
import { useUser } from 'Context/userContext'
// import { useEnroll } from 'Context/enrollContext'
import Notification from 'Components/v1/Notification'
import { useView } from 'Context/viewContext'
// import { Trophy } from 'lucide-react'
// import { useEnroll } from 'Context/enrollContext'
// import MyImage from 'Components/MyImage'
// import { UserCircle } from "lucide-react"
interface Header {
  isMenuActive: boolean,
  setIsMenuActive: any,
  setIsSubMenuOpen: any,
}
function Header_User({ isMenuActive, setIsMenuActive, setIsSubMenuOpen }: Header) {
  // const { logout } = useAuth()
  const { user } = useUser()
  // const {enroll} = useEnroll()
  const { isMobile } = useView()
  // const { updateEnroll } = useEnroll()
  // const navigate = useNavigate()
  return (
    <>
      {isMobile
        ?
        <nav
          // className="bg-[#f2f4fc] shadow-sm flex flex-row z-[9999] absolute top-0  items-top justify-between  w-full py-5 px-4"
          className="bg-[#f5f5f7]  flex flex-row z-[9998] absolute top-0  items-top justify-between  w-full px-8 py-6"
        >
          <div className='flex flex-col'>
            <a href="#" className='font-bold text-sm md:text-xl font-youvah'>Hello, {isMobile ? user.name?.split(" ")[0] : user.name}</a>
            <p className='text-gray-500'>Track your program progress</p>
          </div>
          <span className='rounded-full mt-1'>
          {/* {enroll.isCertificateAvailable && window.location.pathname.includes("learning") && <Trophy onClick={()=>{
navigate(`/certificate/training/${enroll._id}`)
           }} strokeWidth={2} className="w-8 h-8 md:w-10 md:h-10 p-1 hover:bg-gray-100 rounded-xl text-brand cursor-pointer" />} */}
          </span>
          <span className='rounded-full mt-1'>
            <Notification />
          </span>
          <div className="md:hidden">
            <span className='cursor-pointer'>
              <img onClick={() => {
                setIsMenuActive(!isMenuActive)
                setIsSubMenuOpen(false)

              }} width="25" height="25" className='block mt-1 md:hidden' src={isMenuActive ? `https://img.icons8.com/ios-filled/64/multiply.png` : `https://img.icons8.com/ios-glyphs/64/menu--v1.png`} alt="menu--v6" />
            </span>
          </div>
        </nav>
        :
        <nav className='bg-white z-[9998] absolute top-0  w-[calc(100%-17rem)] flex flex-row justify-between font-youvah px-8 py-6'>
          <div className=''>
            <a href="#" className='font-semibold text-2xl'>Hello, {user.name?.split(" ")[0]}</a>
            <p className='text-gray-500 text-sm font-light'>Track your program progress</p>
          </div>
          <div className='flex flex-row gap-10 pr-8 items-center'>

            {/* <MyImage className='w-6 h-6 md:w-10 md:h-10 cursor-pointer' src={Image.AccountIcon} /> */}
           {/* {enroll.isCertificateAvailable && window.location.pathname.includes("learning") && <Trophy onClick={()=>{
navigate(`/certificate/training/${enroll._id}`)
           }} strokeWidth={2} className="w-8 h-8 md:w-10 md:h-10 p-1 hover:bg-gray-100 rounded-xl text-brand cursor-pointer" />} */}
            <Notification />
          </div>
        </nav>
      }
    </>
    // <nav
    //   className="bg-white flex flex-row z-[9999] absolute top-0  items-top justify-between  w-full py-5 px-4"
    // >
    //     <div className='border-[#e2e2e2] flex flex-col gap-2'>
    //       <a href="#" className='font-bold text-lg md:text-xl font-youvah'>Hello, {isMobile ? user.name?.split(" ")[0] : user.name}</a>
    //       <p className='text-gray-500'>Track your course progress</p>
    //     </div>
    //     <span className='rounded-full mt-1'>
    //       <Notification />
    //     </span>
    //     <div className="md:hidden">
    //       <span className='cursor-pointer'>
    //         <img onClick={() => setIsMenuActive(!isMenuActive)} width="25" height="25" className='block mt-1 md:hidden' src={isMenuActive ? `https://img.icons8.com/ios-filled/64/multiply.png` : `https://img.icons8.com/ios-glyphs/64/menu--v1.png`} alt="menu--v6" />
    //       </span>
    //     </div>
    // </nav>
  )
}
export default Header_User


